import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled, Typography } from '@mui/material';

export const DisclaimerStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'reduceSizes' && prop !== 'noMargintop',
})(({ theme, reduceSizes, noMargintop }) => ({
  backgroundColor: theme.palette.colors.infoBackground,
  borderRadius: 5,
  padding: reduceSizes ? '10px' : '8px 6px 12px 12px',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxHeight: '170px',
  marginBottom: !reduceSizes && '24px',
  marginTop: !noMargintop && theme.spacing(2),
}));

export const WrapperStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

export const MainIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '24px',
  color: theme.palette.colors.mainFocused,
  marginRight: '8px',
}));

export const DisclaimerHeadStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.colors.mainFocused,
  fontWeight: 500,
  fontSize: '16px',
}));

export const TextContainerStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasHeading',
})(({ theme, hasHeading }) => ({
  display: 'flex',
  overflow: 'auto',
  flexDirection: 'row',
  marginTop: hasHeading && '8px',

  '@-moz-document url-prefix()': {
    scrollbarColor: `${theme.palette.colors.scrollOnPrimaryBackground} transparent`,
    scrollbarWidth: 'thin',
  },
  '&::-webkit-scrollbar': {
    width: '18px',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '10px',
    border: 'solid 6px transparent',
    boxShadow: `inset 0 0 14px 14px ${theme.palette.colors.scrollOnPrimaryBackground}`,
  },
}));

export const TextStyled = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'reduceSizes',
})(({ theme, reduceSizes }) => ({
  fontSize: reduceSizes ? '10px' : '12px',
  fontWeight: reduceSizes ? 'normal' : 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  letterSpacing: 'normal',
  lineHeight: 'normal',
}));

export const ProofWrapperStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: '8px',
}));

export const ProofIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '18px',
  color: theme.palette.colors.label,
  marginRight: '8px',
}));

export const ProofLabelStyled = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 500,
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));

export const ArrowRightIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '10px',
  color: theme.palette.colors.mainFocused,
  marginRight: '4px',
  float: 'left',
}));
